var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTotalRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5863_152294)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.668,
    cy: 20,
    r: 18,
    fill: "#EEF2FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8584 15.9103L28.4985 16.1203C28.5538 16.2151 28.523 16.3475 28.421 16.4101L21.1344 20.6309C21.0639 20.6618 21.0226 20.6687 21 20.6687C20.9569 20.6687 20.9226 20.6592 20.8933 20.6421L20.8921 20.6414L13.5373 16.3851C13.4354 16.3224 13.4046 16.1901 13.4599 16.0953C13.5185 15.9949 13.6463 15.9607 13.7484 16.0202L13.7497 16.021L20.7913 20.096L21 20.2167L21.2087 20.096L28.2087 16.046L28.21 16.0452C28.3055 15.9895 28.4389 16.0212 28.5011 16.1247L28.8584 15.9103ZM28.8584 15.9103C28.6834 15.6187 28.3 15.5103 28 15.6853L28.6334 16.7687C28.925 16.5937 29.0334 16.2103 28.8584 15.9103Z",
    fill: "white",
    stroke: "#335EF7",
    strokeWidth: 0.833333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28.2159C20.8885 28.2159 20.7917 28.1191 20.7917 28.0076V20.4492C20.7917 20.3377 20.8885 20.2409 21 20.2409C21.1115 20.2409 21.2083 20.3377 21.2083 20.4492V28.0076C21.2083 28.1191 21.1115 28.2159 21 28.2159Z",
    fill: "white",
    stroke: "#335EF7",
    strokeWidth: 0.833333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7192 25.6455L14.718 25.6448C14.193 25.3552 13.7052 24.8469 13.3479 24.2383C12.9907 23.6297 12.7834 22.9539 12.7834 22.3513V17.643C12.7834 17.0405 12.9906 16.3669 13.3478 15.7594C13.7048 15.1521 14.1929 14.643 14.7193 14.3487C14.7195 14.3486 14.7197 14.3485 14.7199 14.3484L19.1687 11.8824L19.1688 11.8823C19.6645 11.6073 20.3225 11.4596 21 11.4596C21.6774 11.4596 22.3353 11.6073 22.831 11.8822C22.8311 11.8822 22.8312 11.8823 22.8312 11.8823L27.2808 14.3571L27.2821 14.3578C27.8071 14.6474 28.2949 15.1557 28.6522 15.7643C29.0094 16.3729 29.2167 17.0487 29.2167 17.6513V22.3596C29.2167 22.9621 29.0095 23.6357 28.6523 24.2432C28.2952 24.8506 27.8071 25.3597 27.2806 25.6539C27.2805 25.654 27.2803 25.6541 27.2802 25.6542L22.8324 28.1197C22.8322 28.1197 22.8321 28.1198 22.832 28.1199C22.331 28.3957 21.6786 28.543 21 28.543C20.3216 28.543 19.6692 28.3957 19.1683 28.12C19.1681 28.1199 19.1679 28.1198 19.1677 28.1197L14.7192 25.6455ZM19.3761 12.2435L19.3761 12.2435L19.3725 12.2455L14.9236 14.7199C14.9234 14.72 14.9232 14.7201 14.923 14.7202C14.4387 14.9878 14.0137 15.4624 13.712 15.974C13.41 16.4859 13.2 17.0882 13.2 17.643V22.3513C13.2 22.9061 13.4101 23.5083 13.7118 24.021C14.0136 24.5338 14.438 25.0096 14.9208 25.2811L14.9225 25.2821L19.3713 27.7564C19.3716 27.7566 19.3718 27.7567 19.3721 27.7569C19.8321 28.0145 20.4312 28.1284 21 28.1284C21.5688 28.1284 22.1679 28.0145 22.6279 27.7569C22.6282 27.7568 22.6285 27.7566 22.6287 27.7564L27.0776 25.2821L27.0793 25.2811C27.5614 25.01 27.9859 24.5368 28.2881 24.0244C28.5902 23.5122 28.8 22.9099 28.8 22.3513V17.643C28.8 17.0882 28.59 16.486 28.2883 15.9733C27.9865 15.4604 27.562 14.9847 27.0793 14.7131L27.0776 14.7122L22.6276 12.2372L22.6276 12.237L22.6178 12.2319C22.1611 11.9936 21.5745 11.8763 21 11.8763C20.4259 11.8763 19.8362 11.9935 19.3761 12.2435Z",
    fill: "white",
    stroke: "#335EF7",
    strokeWidth: 0.833333
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5863_152294",
    x: 0.667969,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5863_152294"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.726419 0 0 0 0 0.803805 0 0 0 0 0.930941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5863_152294"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5863_152294",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTotalRequest);
export default __webpack_public_path__ + "static/media/icon-total-request.f7e70dfc.svg";
export { ForwardRef as ReactComponent };